import { render, staticRenderFns } from "./pre-loader.vue?vue&type=template&id=5edc076e&scoped=true"
import script from "./pre-loader.vue?vue&type=script&lang=js"
export * from "./pre-loader.vue?vue&type=script&lang=js"
import style0 from "./pre-loader.vue?vue&type=style&index=0&id=5edc076e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5edc076e",
  null
  
)

export default component.exports